import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AuthorisedList from "@/Components/common/client/timesheet/AuthorisedList";
import TimesheetTypes from "@/Components/common/client/timesheet/TimesheetTypes";
import { updateactivePages } from "@/reducers/clientcommon";
import {
  deSelectAllCandidate,
  fetchAuthorisedTimesheets,
  setAuthorisedTimesheetsLoading,
  updateFilters,
  updatePagination,
} from "@/reducers/timesheets/timesheetauthorised";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import useTitle from "@/utilities/hooks/useTitle";

const Authorised = () => {
  useTitle("Authorised Timesheets");
  const dispatch = useDispatch();
  const { pagination } = useSelector(
    (state) => state.clientTimesheetAuthorised,
  );
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }

    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAuthorisedTimesheetsLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchAuthorisedTimesheets());
    dispatch(
      updateactivePages({
        activePage: "timesheets",
        activeSubPage: "authorised",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <TimesheetTypes />
      <AuthorisedList />
    </div>
  );
};

export default Authorised;
